import React from "react";

export default function Achievements() {
  return (
    <React.Fragment>
      <div className="mt-3 p-3 section">
        <h1 className="section__h1 mb-4">Достижения</h1>
        <p>Призер олимпиад по веб-дизайну и программированию.</p>
        <p>Участник Малой академии наук Украины.</p>
      </div>
    </React.Fragment>
  );
}
